import React, { useEffect } from "react";
import Types from "prop-types";
import { withTranslation } from "react-i18next";
import { styles } from "./MotInvitationError.styles";
import MotInvitationPageHeader from "./MotInvitationPageHeader";
import ErrorIcon from "../../images/icn_email_error.svg";
import eventAnalytics from "../../analytikaV2";
import { ANALYTIKA_EVENTS } from "../../utils/constants";

const REASON_TRANSLATION_KEY = {
  NOT_FOUND: "invitation_error_reason_not_found",
  IDENTITY_NOT_FOUND: "invitation_error_reason_identity_not_found",
  EXPIRED: "invitation_error_reason_expired",
  ALREADY_ACCEPTED: "invitation_error_reason_already_accepted",
  CANCELLED: "invitation_error_reason_cancelled",
  REJECTED: "invitation_error_reason_rejected",
  REVOKED: "invitation_error_reason_revoked",
  DUPLICATED: "invitation_error_reason_duplicated",
};

const MotInvitationError = ({ t, reason, onClose }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    eventAnalytics.setPageName(ANALYTIKA_EVENTS.PAGE.BUSINESS_INVITATION_ERROR);
    eventAnalytics.publishViewPage(ANALYTIKA_EVENTS.PAGE.BUSINESS_INVITATION_ERROR, {
      error_reason: reason,
    });
  }, [reason]);

  const messageKey = REASON_TRANSLATION_KEY[reason] || "invitation_error_reason_unknown";

  const handleClose = (event) => {
    event.preventDefault();
    eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_TAP_BUTTON, {
      button_name: "close_invitation_error",
      error_reason: reason,
    });
    if (onClose) {
      onClose();
    } else {
      window.location.assign("/logout");
    }
  };

  return (
    <div>
      <MotInvitationPageHeader t={t} />

      <main style={styles.content}>
        <div style={styles.errorIconWrapper} aria-hidden="true">
          <img src={ErrorIcon} alt="" style={styles.errorIconImg} />
        </div>

        <h2 style={styles.pageTitle}>
          {t("business_invitation:invitation_error_title")}
        </h2>

        <div style={styles.infoCard} role="alert">
          <p style={styles.infoCardBody}>
            {t(`business_invitation:${messageKey}`)}
          </p>
        </div>

        <button
          style={styles.closeButton}
          onClick={handleClose}
          aria-label={t("business_invitation:invitation_error_close")}
        >
          {t("business_invitation:invitation_error_close")}
        </button>
      </main>
    </div>
  );
};

MotInvitationError.propTypes = {
  t: Types.func.isRequired,
  reason: Types.string,
  onClose: Types.func,
};

export default withTranslation()(MotInvitationError);
export const MotInvitationErrorUnwrapped = MotInvitationError;
